import React from 'react';

import { Typography } from '@/components/atoms/Typography';

export interface TextSection {
  title: string;
  items: string[];
}

export interface Props {
  leftSection: TextSection;
  rightSection: TextSection;
  imageSrc: string;
}

export const HighlightGrid: React.FC<Props> = ({ leftSection, rightSection, imageSrc }) => {
  return (
    <div className="md:grid grid-cols-3 p-10 gap-5 py-10 bg-slate-100/80 justify-center items-center">
      <div className="md:text-right text-center max-w-md flex flex-col justify-self-end">
        <Typography tag="p" variant="h3" color="primary">
          {leftSection.title}
        </Typography>
        <span className="mt-8 flex flex-col">
          {leftSection.items.map((text, index) => (
            <React.Fragment key={text + '-' + index}>
              <Typography variant="paragraph">{text}</Typography>
              {index < leftSection.items.length - 1 && <div className="w-full h-[1px] bg-slate-300 my-3" />}
            </React.Fragment>
          ))}
        </span>
      </div>
      <img alt="" width={400} height={200} src={imageSrc} className="m-auto" />
      <div className="md:text-left text-center max-w-md">
        <Typography tag="p" variant="h3" color="primary">
          {rightSection.title}
        </Typography>
        <span className="mt-8 flex flex-col">
          {rightSection.items.map((text, index) => (
            <React.Fragment key={text + '-' + index}>
              <Typography variant="paragraph">{text}</Typography>
              {index < rightSection.items.length - 1 && <div className="w-full h-[1px] bg-slate-300 my-3" />}
            </React.Fragment>
          ))}
        </span>
      </div>
    </div>
  );
};
